import { Observable } from 'rxjs';
import { AlertaEntity } from '../models/alertas.model';

/**
 * Puerto de tiempo real (RF-59). MVP: liveQuery de Dexie (funciona entre pestañas).
 * Integración: socket.io namespace `/asistencia-mml`, sala `usuario:<id>`, evento `alerta:nueva`.
 */
export abstract class TiempoRealPort {
  abstract alertasNuevas(destinatarioId: string): Observable<AlertaEntity[]>;
}
